import {cloneObject, getPassengerType, planeRoutePush} from "@/common/utility/utils";
import FlightOrder from 'common/model/flight/flightOrder.js'
import IntlFlightOrder from 'common/model/intlFlight/intlFlightOrder.js'
import {kpiCacheSet, kpiFlightGetFlightIndexInitInfo, kpiIntlflightGet} from 'api'
import {getFlightClassLimitsFormatFun} from "@/pages/home/home/plane-query";
import {kpiFlightGetCabinClass, kpiIntlflightGetCabinClass} from "@/api";

export default {
  data() {
    return {
      /** 国内机票订单 */
      dFlightOrder: new FlightOrder(),
      /** 国际机票订单 */
      iFlightOrder: new IntlFlightOrder(),

      planeOptions: [this.$t('OneWay'), this.$t('RoundTrip'), this.$t('OverseasMultiCity')],
      planeSelectIndex: 0,

      SelectedFlights: [
        {
          DepartObject: {},
          ArrivalObject: {},
          DepartDate: this.getNewDate(this.beTime(new Date()), 0, 0, 1),
          rotate: 0
        },
        {
          DepartObject: {},
          ArrivalObject: {},
          DepartDate: this.getNewDate(this.beTime(new Date()), 0, 0, 2),
          rotate: 0
        }
      ], // 单程往返行程
      mulSelectedFlights: [
        {
          DepartObject: {},
          ArrivalObject: {},
          DepartDate: this.getNewDate(this.beTime(new Date()), 0, 0, 1),
          rotate: 0
        },
        {
          DepartObject: {},
          ArrivalObject: {},
          DepartDate: this.getNewDate(this.beTime(new Date()), 0, 0, 3),
          rotate: 0
        }
      ], // 多程行程信息

      showPlaneAddressPicker: false,
      addressPickerOptions: [this.$t('China'), this.$t('InternationalRegion')],
      whichSegments: {index: 0, from: true},
      tabActiveIndex: 0,

      /******************日期******************/
      showPlaneDatePicker: false,
      IntelFlightSearchLimits: [], // 国际舱位可选列表
      IntelPrivateFlightSearchLimits: [], // 国际 因私舱位可选列表

      PlaneAdultAmount: 1,
      PlaneChildAmount: 0,
      PlaneInfantAmount: 0,

      /** 舱位 */
      flightClass: {text: '', value: undefined},
      intlFlightClass: {text: '', value: undefined},

      flightClassDetails: {},

      showFlightClass: false,
      showSelectPeopleCount: false,
    }
  },
  computed: {
    isIntlPlane() {
      let isIntlPlane = false;
      if (this.isPlaneMultiPass) {
        isIntlPlane = this.mulSelectedFlights.findIndex(v => this.mixinPlaneCheckIsIntlCity(v.DepartObject, v.ArrivalObject)) >= 0
      } else {
        let item = this.SelectedFlights[0]
        isIntlPlane = this.mixinPlaneCheckIsIntlCity(item.DepartObject, item.ArrivalObject)
      }
      // if (this.TravelType === 0 && !this.hasPower('因公:机票:国内机票查询') && this.hasPower('因公:机票:国际机票查询')) {
      //   isIntlPlane = true
      // }
      // if (this.TravelType === 1 && !this.hasPower('因私:国内机票') && this.hasPower('因私:国际机票')) {
      //   isIntlPlane = true
      // }
      console.log('isIntlPlane', isIntlPlane)
      return isIntlPlane
    },
    /** 是否是多程 */
    isPlaneMultiPass() {
      let isMultiPass = false
      let tripType = this.planeOptions[this.planeSelectIndex]
      if (tripType === this.$t('OverseasMultiCity')) {
        isMultiPass = true
      }
      return isMultiPass
    },
    planeDatePickerDate() {
      let planeDatePickerDate = ''
      let index = this.whichSegments.index
      if (this.isPlaneMultiPass) {
        planeDatePickerDate = this.mulSelectedFlights[index] ? this.mulSelectedFlights[index].DepartDate : ''
      } else {
        index = 0
        planeDatePickerDate = this.SelectedFlights[index] ? this.SelectedFlights[index].DepartDate : ''
      }
      return planeDatePickerDate
    },
    planeDatePickerEndDate() {
      let planeDatePickerEndDate = ''
      let index = this.whichSegments.index + 1
      if (this.isPlaneMultiPass) {
        planeDatePickerEndDate = this.mulSelectedFlights[index] ? this.mulSelectedFlights[index].DepartDate : ''
      } else {
        index = 1
        planeDatePickerEndDate = this.SelectedFlights[index] ? this.SelectedFlights[index].DepartDate : ''
      }
      return planeDatePickerEndDate
    },
    planeOverdueDate() {
      // DateCtrlLevel 日期管控等级 0 不管控 1 强管控 2 弱管控
      let {isPlaneMultiPass, mulSelectedFlights, whichSegments} = this
      let overdueDate = null
      if (isPlaneMultiPass) {
        overdueDate = mulSelectedFlights[whichSegments.index - 1] ? mulSelectedFlights[whichSegments.index - 1].DepartDate : null
      } else {
        overdueDate = null
      }
      return overdueDate
    },
    choosePassengerFirst4Plane() {
      return Number(this.TravelType) === 0 && Number(this.getSetting('国内机票配置:正常订单:查询顺序')) === 1
    },
    choosePassengerFirst4IntlPlane() {
      return Number(this.TravelType) === 0 && Number(this.getSetting('国际机票配置:正常订单:查询顺序')) === 1
    },
    FlightClassText() {
      let FliClas = this.isIntlPlane ? this.intlFlightClass : this.flightClass
      return FliClas ? FliClas.text : '不限舱位'
    },
    FlightClassValue() {
      let FliClas = this.isIntlPlane ? this.intlFlightClass : this.flightClass
      return FliClas ? FliClas.value : ''
    },
    FlightClassLimits() {
      let limits = []
      if (this.isIntlPlane) {
        limits = Number(this.TravelType) === 0 ? this.IntelFlightSearchLimits : this.IntelPrivateFlightSearchLimits
      } else {
        limits = Number(this.TravelType) === 0 ? this.flightClassDetails.FlightSearchLimits : this.flightClassDetails.PrivateFlightSearchLimits
      }
      return getFlightClassLimitsFormatFun(limits || [])
    },
    showCarryChildInfant() { // 是否展示儿童婴儿价格
      let showCarryChildInfant = false
      if (this.TravelType === 0) {
        showCarryChildInfant = !this.isIntlPlane && this.getSetting('国内机票配置:正常订单:展示儿童婴儿价格')
      } else {
        showCarryChildInfant = !this.isIntlPlane
      }
      return showCarryChildInfant
    },
    Passengers() {
      return this.isIntlPlane ? this.iFlightOrder.Passengers : this.dFlightOrder.Passengers
    },
    PassengerNames() { // 是否展示儿童婴儿价格
      let list = this.isIntlPlane ? this.iFlightOrder.Passengers : this.dFlightOrder.Passengers
      return list.map(v => this.$getPassengerName(v)).join('、') || this.$t('SelectThePassenger')
    },
  },
  watch: {
    TravelType() {
      this.SelectedFlights = this.mixinPlaneGetFilterInterPlaneCityHistory(this.SelectedFlights)
      this.mulSelectedFlights = this.mixinPlaneGetFilterInterPlaneCityHistory(this.SelectedFlights)
    },
    isIntlPlane() {
      this.PlaneChildAmount = 0
      this.PlaneInfantAmount = 0
      this.dFlightOrder.Passengers = []
      this.iFlightOrder.Passengers = []
      // 乘客发生变化是 更新对应可选舱等
      if (this.TravelType === 0) {
        this.mixinGetIntlFlightInitWithAjax('updateWithPassengers')
        this.mixinGetFlightInitWithAjax('updateWithPassengers')
      }
    }
  },
  methods: {
    /** 初始换机票权限 */
    mixinPlaneInitPersonalPower() {
      // 因公
      if (Number(this.TravelType) === 0) {
        if (this.hasPower('因公:机票')) {
          if (this.hasPower('因公:机票:国内机票查询') && !this.hasPower('因公:机票:国际机票查询')) {
            this.addressPickerOptions = [this.$t('China')]
            this.tabActiveIndex = 0
          } else {
            this.addressPickerOptions = [this.$t('China'), this.$t('InternationalRegion')]
          }
        }
      } else {
        if (this.hasPower('因私')) {
          if (this.hasPower('因私:国内机票') && !this.hasPower('因私:国际机票')) {
            this.addressPickerOptions = [this.$t('China')]
            this.tabActiveIndex = 0
          } else {
            this.addressPickerOptions = [this.$t('China'), this.$t('InternationalRegion')]
          }
        }
      }
    },

    mixinPlaneGetListItemWithValue(flightClass, SearchLimits) {
      let index = 0
      if (flightClass && SearchLimits.findIndex(v => v.value === flightClass.value) >= 0) {
        index = SearchLimits.findIndex(v => v.value === flightClass.value)
      }
      return SearchLimits[index] ? {...SearchLimits[index]} : {text: '', value: undefined}
    },

    /** 国内机票舱位信息 初始化 */
    mixinGetFlightInitWithAjax(type) {
      let ajaxFun = kpiFlightGetFlightIndexInitInfo;
      if (type === 'updateWithPassengers') {
        ajaxFun = kpiFlightGetCabinClass
      }
      ajaxFun({
        TravelType: this.TravelType,
        SelectedPassengers: this.dFlightOrder.Passengers,
      }).then((res) => {
        let HISTORY_FLIGHTCLASS = ''
        if (type === 'updateWithPassengers') {
          this.flightClassDetails.FlightSearchLimits = res.ResultData.FlightSearchLimits || []
          HISTORY_FLIGHTCLASS = this.flightClass || null
        } else {
          this.flightClassDetails = res.ResultData
          HISTORY_FLIGHTCLASS = window.localStorage.HISTORY_FLIGHTCLASS ? JSON.parse(window.localStorage.HISTORY_FLIGHTCLASS) : null
        }

        // 国内
        let SearchLimits = Number(this.TravelType) === 0 ? this.flightClassDetails.FlightSearchLimits : this.flightClassDetails.PrivateFlightSearchLimits
        let pickerdata = SearchLimits.map(v => {
          return {
            text: v.Name,
            value: v.Value
          }
        })
        this.flightClass = this.mixinPlaneGetListItemWithValue(HISTORY_FLIGHTCLASS, pickerdata)
      })
    },

    mixinGetIntlFlightInitWithAjax(type) {
      let ajaxFun = kpiIntlflightGet;
      if (type === 'updateWithPassengers') {
        ajaxFun = kpiIntlflightGetCabinClass
      }
      ajaxFun({
        TravelType: this.TravelType,
        SelectedPassengers: this.iFlightOrder.Passengers,
      }).then((res) => {
        let HISTORY_INTLFLIGHTCLASS = ''
        // 人变化 更新对应舱等
        if (type === 'updateWithPassengers') {
          this.IntelFlightSearchLimits = (res.ResultData.FlightSearchLimits || []).map(v => {
            return {
              ...v,
              text: v.Name,
              value: v.Value
            }
          })
          HISTORY_INTLFLIGHTCLASS = this.intlFlightClass || null
        } else {
          this.IntelFlightSearchLimits = (res.ResultData.FlightSearchLimits || []).map(v => {
            return {
              ...v,
              text: v.Name,
              value: v.Value
            }
          })
          this.IntelPrivateFlightSearchLimits = (res.ResultData.PrivateFlightSearchLimits || []).map(v => {
            return {
              ...v,
              text: v.Name,
              value: v.Value
            }
          })
          HISTORY_INTLFLIGHTCLASS = window.localStorage.HISTORY_INTLFLIGHTCLASS ? JSON.parse(window.localStorage.HISTORY_INTLFLIGHTCLASS) : null
        }

        let SearchLimits = Number(this.TravelType) === 0 ? this.IntelFlightSearchLimits : this.IntelPrivateFlightSearchLimits
        this.intlFlightClass = this.mixinPlaneGetListItemWithValue(HISTORY_INTLFLIGHTCLASS, SearchLimits)
      })
    },

    // 根据 因公因私 变化重置舱位
    mixinReSetFlightClassWithTravelType() {
      // 因公因私切换 清空选中的人 及 成人儿童婴儿数
      this.dFlightOrder.Passengers = []
      this.iFlightOrder.Passengers = []
      this.PlaneAdultAmount = 1
      this.PlaneChildAmount = 0
      this.PlaneInfantAmount = 0

      if (!this.isIntlPlane) {
        // 乘客发生变化是 更新对应可选舱等
        if (this.TravelType === 0) {
          this.mixinGetFlightInitWithAjax('updateWithPassengers')
        } else {
          let SearchLimits = Number(this.TravelType) === 0 ? this.flightClassDetails.FlightSearchLimits : this.flightClassDetails.PrivateFlightSearchLimits
          let pickerdata = SearchLimits.map(v => {
            return {
              text: v.Name,
              value: v.Value
            }
          })
          this.flightClass = this.mixinPlaneGetListItemWithValue(this.flightClass, pickerdata)
        }
      } else {
        // 乘客发生变化是 更新对应可选舱等
        if (this.TravelType === 0) {
          this.mixinGetIntlFlightInitWithAjax('updateWithPassengers')
        } else {
          let SearchLimits = Number(this.TravelType) === 0 ? this.IntelFlightSearchLimits : this.IntelPrivateFlightSearchLimits
          this.intlFlightClass = this.mixinPlaneGetListItemWithValue(this.intlFlightClass, SearchLimits)
        }
      }
    },

    /** 单程往返多程切换 */
    mixinPlaneTabSelect(index = 0) {
      this.planeSelectIndex = index
    },

    /** 往返程切换 */
    mixinPlaneSwitchCity(index = 0) {
      if (this.isPlaneMultiPass) {
        let DepartObject = cloneObject(this.mulSelectedFlights[index].DepartObject)
        let ArrivalObject = cloneObject(this.mulSelectedFlights[index].ArrivalObject)
        this.mulSelectedFlights[index].DepartObject = ArrivalObject
        this.mulSelectedFlights[index].ArrivalObject = DepartObject
      } else {
        let DepartObject = cloneObject(this.SelectedFlights[index].DepartObject)
        let ArrivalObject = cloneObject(this.SelectedFlights[index].ArrivalObject)
        this.SelectedFlights[index].DepartObject = ArrivalObject
        this.SelectedFlights[index].ArrivalObject = DepartObject
      }
    },

    /** 出发 */
    mixinPlaneClickDeparture(index) {
      this.showPlaneAddressPicker = true
      this.whichSegments.index = index || 0
      this.whichSegments.from = true
    },

    /** 到达 */
    mixinPlaneClickArrive(index) {
      this.showPlaneAddressPicker = true
      this.whichSegments.index = index || 0
      this.whichSegments.from = false
    },

    /** 地址选择回调 */
    mixinPlaneSetAddress(val) {
      if (this.isPlaneMultiPass) {
        if (this.whichSegments.from) {
          this.mulSelectedFlights[this.whichSegments.index].DepartObject = val
        } else {
          this.mulSelectedFlights[this.whichSegments.index].ArrivalObject = val
        }
      } else {
        if (this.whichSegments.from) {
          this.SelectedFlights[this.whichSegments.index].DepartObject = val
        } else {
          this.SelectedFlights[this.whichSegments.index].ArrivalObject = val
        }
      }
    },

    /** 日期点击 */
    mixinPlaneClickDate(index, from) {
      this.showPlaneDatePicker = true
      this.whichSegments.index = index || 0
      this.whichSegments.from = from
    },

    /** 日期选择回调 */
    mixinPlaneSetDate(DepartDate, ReturnDate) {
      let index = this.whichSegments.index
      let nextIndex = index + 1
      let today = this.beTime(new Date())
      if (this.isPlaneMultiPass) {
        if (DepartDate) {
          this.mulSelectedFlights[index].DepartDate = DepartDate
        }
        if (ReturnDate) {
          this.mulSelectedFlights[nextIndex].DepartDate = ReturnDate
        }
        /** 如果选择的去程日期小于今天, 则自动再去选择明天这个日期 */
        if (this.mulSelectedFlights[index] && this.mulSelectedFlights[index].DepartDate && (this.mulSelectedFlights[index].DepartDate < today)) {
          this.mulSelectedFlights[index].DepartDate = this.getNewDate(today, 0, 0, 1)
        }

        /** 如果选择的去程日期大于返程日期, 则自动修改返程日期为去程日期+3 */
        if (
          this.mulSelectedFlights[nextIndex] &&
          this.mulSelectedFlights[nextIndex].DepartDate &&
          (this.mulSelectedFlights[index].DepartDate > this.mulSelectedFlights[nextIndex].DepartDate)
        ) {
          let offsetD = 3
          for (let i = index, len = this.mulSelectedFlights.length; i < len; i++) {
            if (this.mulSelectedFlights[i + 1]) {
              // 如果默认三天后的日期 大于最大可选日期 则默认 最大可选日期 若没有日期限制则按原定逻辑
              let DepartDate = this.getNewDate(this.mulSelectedFlights[i].DepartDate, 0, 0, offsetD)
              this.mulSelectedFlights[i + 1].DepartDate = DepartDate
            }
          }
        }
      } else {
        if (DepartDate) {
          this.SelectedFlights[index].DepartDate = DepartDate
        }
        if (ReturnDate) {
          this.SelectedFlights[nextIndex].DepartDate = ReturnDate
        }
        /** 如果选择的去程日期小于今天, 则自动再去选择明天这个日期 */
        if (this.SelectedFlights[index] && this.SelectedFlights[index].DepartDate && (this.SelectedFlights[index].DepartDate < today)) {
          this.SelectedFlights[index].DepartDate = this.getNewDate(today, 0, 0, 1)
        }

        /** 如果选择的去程日期大于返程日期, 则自动修改返程日期为去程日期+1 */
        if (
          this.SelectedFlights[nextIndex] &&
          this.SelectedFlights[nextIndex].DepartDate &&
          (this.SelectedFlights[index].DepartDate > this.SelectedFlights[nextIndex].DepartDate)
        ) {
          let offsetD = 1
          // 如果默认三天后的日期 大于最大可选日期 则默认 最大可选日期 若没有日期限制则按原定逻辑
          let DepartDate = this.getNewDate(this.SelectedFlights[index].DepartDate, 0, 0, offsetD)
          this.SelectedFlights[nextIndex].DepartDate = DepartDate
        }
      }
    },

    /** 再加一程 */
    mixinPlaneAddSegment() {
      let length = this.mulSelectedFlights.length
      // 检验之前的行程选择是否完成
      if (!this.mulSelectedFlights[length - 1].DepartObject.AirPortCode) {
        // this.$toast(`请完善第${length}程的出发城市`)
        this.$toast(this.$t('PleaseChooseRouteDepartCity_x', 'function', [length]))
        return
      } else if (!this.mulSelectedFlights[length - 1].ArrivalObject.AirPortCode) {
        // this.$toast(`请完善第${length}程的到达城市`)
        this.$toast(this.$t('PleaseChooseRouteArrivalCity_x', 'function', [length]))
        return
      } else if (this.mulSelectedFlights[length - 1].DepartObject.AirPortCode === this.mulSelectedFlights[length - 1].ArrivalObject.AirPortCode) {
        this.$toast(this.$t('DepartureCityAndArrivalCityCannotBeSame'))
        return
      }

      let DepartDate = this.getNewDate(this.mulSelectedFlights[length - 1].DepartDate, 0, 0, 3)
      // if (this.IsOA && this.beTime(this.oaDetails.DepartEndDate) < DepartDate) {
      this.$set(this.mulSelectedFlights, length, {
        DepartObject: this.IsOA ? {} : this.mulSelectedFlights[length - 1].ArrivalObject,
        ArrivalObject: {},
        DepartDate: DepartDate,
        rotate: 0
      })
    },

    /** 删除一程 */
    mixinPlaneClearSegment(index) {
      this.mulSelectedFlights.splice(index, 1)
    },

    /** 舱位点击事件 */
    mixinPlaneSelectCabins() {
      this.showFlightClass = true
    },

    /** 舱位选择回调 */
    mixinPlaneSetCabins(val, index, text) {
      let FliClass = {text: text[0], value: val[0]}
      if (this.isIntlPlane) {
        this.intlFlightClass = {...FliClass}
      } else {
        this.flightClass = {...FliClass}
      }
    },

    /** 选择成人儿童数 */
    mixinPlaneSelectPeopleCountCallback(adu, chi, inf) {
      this.PlaneAdultAmount = adu
      this.PlaneChildAmount = chi
      this.PlaneInfantAmount = inf
    },

    /** 成人 */
    mixinPlaneAdultClick() {
      this.showSelectPeopleCount = true
    },

    /** 多程校验 */
    mixinPlaneCheckMultiPass() {
      /** 是否通过本地校验 */
      let pass = true
      /** 有未完善的行程 */
      let noValueFlight = false
      /** 出发城市和到达城市不得相同 */
      let sameAirportCode = false
      let accordDateLimit = false // 符合日期限制
      let preDate = '' // 上一层日期
      let accordDateLimitIndex = ''
      this.mulSelectedFlights.forEach((element, index) => {
        if (
          !(element.DepartObject && element.DepartObject.AirPortCode) ||
          !(element.ArrivalObject && element.ArrivalObject.AirPortCode) ||
          !element.DepartDate
        ) {
          noValueFlight = true
        }
        if (element.DepartObject && element.ArrivalObject && element.DepartObject.CityCode === element.ArrivalObject.CityCode) {
          sameAirportCode = true
        }

        // 日期必须大于等于上一程日期
        if (preDate && element.DepartDate < preDate) {
          accordDateLimit = true
          if (!accordDateLimitIndex) {
            accordDateLimitIndex = index + 1
          }
        }
        preDate = element.DepartDate
      })
      if (noValueFlight) {
        this.$toast(this.$t('PleaseCompleteYourSegments'))
        pass = false
        return
      } else if (sameAirportCode) {
        this.$toast(this.$t('DepartureCityAndArrivalCityCannotBeSame'))
        pass = false
        return
      } else if (accordDateLimit) {
        this.$toast(this.$t('RouteDepartDateCannotBeLessThanLastRoute_x_x', 'function', [accordDateLimitIndex, accordDateLimitIndex - 1]))
        pass = false
        return
      } else if (this.choosePassengerFirst4Plane && !this.isIntlPlane && this.dFlightOrder.Passengers.length === 0) {
        this.$toast(this.$t(`PleaseSelect_x`, 'function', [this.$t('PassengerFlight')]))
        pass = false
        return
      } else if (this.choosePassengerFirst4IntlPlane && this.isIntlPlane && this.iFlightOrder.Passengers.length === 0) {
        this.$toast(this.$t(`PleaseSelect_x`, 'function', [this.$t('PassengerFlight')]))
        pass = false
        return
      }
      return pass
    },

    /** 选人回调 */
    mixinDelegatePlaneWithConfirm(Passengers) {
      if (this.isIntlPlane) {
        this.iFlightOrder.Passengers = [...Passengers]
        this.TravelType === 0 && this.mixinGetIntlFlightInitWithAjax('updateWithPassengers')
      } else {
        this.dFlightOrder.Passengers = [...Passengers]
        this.TravelType === 0 && this.mixinGetFlightInitWithAjax('updateWithPassengers')
      }
    },

    /** 下一步跳转查询 */
    mixinPlaneGoQuery(Passengers) {
      if (this.isPlaneMultiPass) { // 多程
        if (!this.mixinPlaneCheckMultiPass()) return
        if (!this.isIntlPlane) {
          // 国内
          this.dFlightOrder.SelectedFlights = this.mulSelectedFlights.map(v => {
            v.LowestPriceFlight = {}
            v.ViolationCabinRankName = ''
            v.ViolationCabinRankReason = ''
            v.DepartCode = v.DepartObject.AirPortCode
            v.ArrivalCode = v.ArrivalObject.AirPortCode
            v.FlightNo = ''
            v.CabinID = ''
            return v
          })
          this.dFlightOrder.FlightClass = this.flightClass.value // 舱位类型
          this.dFlightOrder.TravelType = this.TravelType
          this.dFlightOrder.IsOA = false
          this.dFlightOrder.choosePassengerFirst = this.dFlightOrder.Passengers.length > 0
          this.dFlightOrder.SegmentType = this.mixinPlaneGetSegmentType(this.dFlightOrder.SelectedFlights)
          this.mixinPlaneFixedAdultAndChildAndInfant()
        } else {
          // 至少选择一个国际城市/港澳台
          if (this.mulSelectedFlights.findIndex(v => this.mixinPlaneCheckIsIntlCity(v.DepartObject, v.ArrivalObject)) < 0) {
            this.$toast(this.$t('PleaseSelectAtLeastOneCityOverseas'))
            return
          }
          // 国际
          this.iFlightOrder.SearchParams.Segments = this.mulSelectedFlights.map(v => {
            v.DepartureTime = v.DepartDate
            v.DepartureAirportCode = v.DepartObject.AirPortCode
            v.ArrivalAirPortCode = v.ArrivalObject.AirPortCode
            return v
          })
          this.iFlightOrder.SearchParams.FlightClass = this.intlFlightClass.value // 舱位类型
          this.iFlightOrder.TravelType = this.TravelType
          this.iFlightOrder.IsOA = false
          this.iFlightOrder.choosePassengerFirst = this.iFlightOrder.Passengers.length > 0
          this.iFlightOrder.SegmentType = this.mixinPlaneGetSegmentType(this.iFlightOrder.SearchParams.Segments)
          this.mixinPlaneFixedAdultAndChildAndInfant()
        }
      } else {
        if (!this.SelectedFlights[0].DepartObject || this.noValue(this.SelectedFlights[0].DepartObject.CityCode)) {
          this.$toast(this.$t('PleaseSelectTheDepartureCity'))
          return
        } else if (!this.SelectedFlights[0].ArrivalObject || this.noValue(this.SelectedFlights[0].ArrivalObject.CityCode)) {
          this.$toast(this.$t('PleaseSelectArrivalCity'))
          return
        } else if (this.SelectedFlights[0].DepartObject.CityName_CN === this.SelectedFlights[0].ArrivalObject.CityName_CN) {
          this.$toast(this.$t('DepartureCityAndArrivalCityCannotBeSame'))
          return
        } else if (!this.SelectedFlights[0].DepartDate) {
          this.$toast(this.$t('PleaseSelectADepartureDate'))
          return
        } else if (this.planeOptions[this.planeSelectIndex] === this.$t('RoundTrip') && !this.SelectedFlights[1].DepartDate) {
          this.$toast(this.$t('PleaseSelectBackDate'))
          return
        } else if (this.choosePassengerFirst4Plane && !this.isIntlPlane && this.dFlightOrder.Passengers.length === 0) {
          this.$toast(this.$t(`PleaseSelect_x`, 'function', [this.$t('PassengerFlight')]))
          return
        } else if (this.choosePassengerFirst4IntlPlane && this.isIntlPlane && this.iFlightOrder.Passengers.length === 0) {
          this.$toast(this.$t(`PleaseSelect_x`, 'function', [this.$t('PassengerFlight')]))
          return
        }

        let DepartObject = JSON.parse(JSON.stringify(this.SelectedFlights[0].DepartObject))
        let ArrivalObject = JSON.parse(JSON.stringify(this.SelectedFlights[0].ArrivalObject))
        this.SelectedFlights[1].DepartObject = ArrivalObject
        this.SelectedFlights[1].ArrivalObject = DepartObject

        if (!this.isIntlPlane) {
          // 国内
          this.dFlightOrder.SelectedFlights = this.SelectedFlights.map(v => {
            v.LowestPriceFlight = {}
            v.ViolationCabinRankName = ''
            v.ViolationCabinRankReason = ''
            v.DepartCode = v.DepartObject.AirPortCode
            v.ArrivalCode = v.ArrivalObject.AirPortCode
            v.FlightNo = ''
            v.CabinID = ''
            return v
          })
          this.dFlightOrder.FlightClass = this.flightClass.value // 舱位类型
          this.dFlightOrder.TravelType = this.TravelType
          this.dFlightOrder.IsOA = false
          if (this.planeOptions[this.planeSelectIndex] === this.$t('OneWay')) {
            this.dFlightOrder.SelectedFlights = this.dFlightOrder.SelectedFlights.slice(0, 1)
          } else {
            this.dFlightOrder.SelectedFlights = this.dFlightOrder.SelectedFlights.slice(0, 2)
          }
          this.dFlightOrder.choosePassengerFirst = this.dFlightOrder.Passengers.length > 0;
          this.dFlightOrder.SegmentType = this.mixinPlaneGetSegmentType(this.dFlightOrder.SelectedFlights)

          this.mixinPlaneFixedAdultAndChildAndInfant()
        } else {
          // 国际
          this.iFlightOrder.SearchParams.Segments = this.SelectedFlights.map(v => {
            v.DepartureTime = v.DepartDate
            v.DepartureAirportCode = v.DepartObject.AirPortCode
            v.ArrivalAirPortCode = v.ArrivalObject.AirPortCode
            return v
          })
          this.iFlightOrder.SearchParams.FlightClass = this.intlFlightClass.value // 舱位类型
          this.iFlightOrder.TravelType = this.TravelType
          this.iFlightOrder.IsOA = false
          this.iFlightOrder.choosePassengerFirst = this.iFlightOrder.Passengers.length > 0;
          let Segments = this.iFlightOrder.SearchParams.Segments
          if (this.planeOptions[this.planeSelectIndex] === this.$t('OneWay')) {
            this.iFlightOrder.SearchParams.Segments = Segments.slice(0, 1)
          } else {
            this.iFlightOrder.SearchParams.Segments = Segments.slice(0, 2)
          }
          this.iFlightOrder.SegmentType = this.mixinPlaneGetSegmentType(this.iFlightOrder.SearchParams.Segments)
          // 至少选择一个国际城市/港澳台
          if (this.iFlightOrder.SearchParams.Segments.findIndex(v => this.mixinPlaneCheckIsIntlCity(v.DepartObject, v.ArrivalObject)) < 0) {
            this.$toast(this.$t('PleaseSelectAtLeastOneCityOverseas'))
            return
          }
          this.mixinPlaneFixedAdultAndChildAndInfant()
        }
      }

      this.mixinPlaneSetLocalStoryWithSegments()
      this.mixinPlaneSetHistoryTripStorage() // 设置历史记录的缓存
    },

    mixinPlaneFixedAdultAndChildAndInfant() {
      let list = this.isIntlPlane ? this.iFlightOrder.Passengers : this.dFlightOrder.Passengers
      let Segments = this.isIntlPlane ? this.iFlightOrder.SearchParams.Segments : this.dFlightOrder.SelectedFlights
      let lastSegmentTakeOffTime = Segments[Segments.length - 1].DepartDate
      /** 校验乘客信息 */
      if (this.mixinCheckPassengersFun(list, lastSegmentTakeOffTime)) {
        return
      }
      //乘客类型 0-未知 1-成人 2-儿童 3-婴儿
      let AdultAmountValue = list.filter(v => Number(v.PassengerType) !== 2 && Number(v.PassengerType) !== 3).length;
      let ChildAmountValue = list.filter(v => Number(v.PassengerType) === 2).length;
      let InfantAmountValue = list.filter(v => Number(v.PassengerType) === 3).length;
      if (
        list.length > 0 &&
        !(this.PlaneAdultAmount === AdultAmountValue && this.PlaneChildAmount === ChildAmountValue && this.PlaneInfantAmount === InfantAmountValue)
      ) {
        this.PlaneAdultAmount = AdultAmountValue
        this.PlaneChildAmount = ChildAmountValue
        this.PlaneInfantAmount = InfantAmountValue
        this.mixinPlaneSwitchWithPeopleAmount(this.PlaneChildAmount, this.PlaneInfantAmount)
      } else {
        this.mixinPlaneSwitchWithPeopleAmount(this.PlaneChildAmount, this.PlaneInfantAmount)
      }
    },

    // 根据国内国际 分发
    mixinPlaneSwitchWithPeopleAmount(ChildAmountValue, InfantAmountValue) {
      if (this.isIntlPlane) {
        this.mixinIntlPlaneGotoInforList()
      } else {
        this.dFlightOrder.IsCarryChild = ChildAmountValue > 0 // 带儿童
        this.dFlightOrder.IsCarryInfant = InfantAmountValue > 0 // 带婴儿
        this.mixinPlaneGotoInforList()
      }
    },

    mixinCheckPassengersFun(list, lastSegmentTakeOffTime) {
      let len = list.length
      for (let i = 0; i < len; i++) {
        list[i] = {...this.mixinPlaneGetPassengersItem(list[i], this.showCarryChildInfant ? lastSegmentTakeOffTime : '')}
        // if (this.showCarryChildInfant && (list[i].PassengerType === 2 || list[i].PassengerType === 3)) {
        //   this.$toast(this.$t('ChildAndBabyNonSupportBookable'))
        //   return true
        // }
      }
    },
    /** 校验乘客完整信息 */
    mixinPlaneGetPassengersItem (item, lastSegmentTakeOffTime) {
      if (!this.isIntlPlane) {
        item.PassengerType = getPassengerType(item.Birthday, lastSegmentTakeOffTime)
      }
      let RefsCPassenger = this.$refs.RefsCPassenger
      if (RefsCPassenger) {
        RefsCPassenger._initPowerDetails()
        return RefsCPassenger._checkList(item)
      }
      return {...item}
    },

    mixinPlaneGotoInforList() {
      let params = {
        CacheKey: `df${Number(new Date())}`,
        CacheValue: JSON.stringify(this.dFlightOrder)
      }
      kpiCacheSet(params).then((res) => {
        planeRoutePush({path: '/planeTicket/inforList', query: {tmp: params.CacheKey, back: 1}})
      })
    },
    mixinIntlPlaneGotoInforList() {
      let params = {
        CacheKey: `if${Number(new Date())}`,
        CacheValue: JSON.stringify(this.iFlightOrder)
      }
      kpiCacheSet(params).then((res) => {
        planeRoutePush({path: '/intlPlaneTicket/inforList', query: {tmp: params.CacheKey, back: 1}})
      })
    },

    /** 计算行程类型 */
    mixinPlaneGetSegmentType(segment) {
      if (segment.length === 1) {
        return 0
      } else if (segment.length === 2) {
        if (
          segment[0].DepartObject && segment[1].ArrivalObject &&
          (segment[0].DepartObject.CityCode === segment[1].ArrivalObject.CityCode) &&
          (segment[0].ArrivalObject.CityCode === segment[1].DepartObject.CityCode)
        ) {
          return 1
        } else {
          return 2
        }
      } else {
        return 2
      }
    },

    /** 获取机票缓存行程信息 */
    mixinPlaneGetLocalStorageWithQuery() {
      if (!this.PersonalPower) {
        return
      }
      if (window.localStorage.HISTORY_QUERY_PLANE) {
        let res = this.mixinPlaneGetFilterInterPlaneCityHistory(JSON.parse(window.localStorage.HISTORY_QUERY_PLANE))
        this.whichSegments.index = 0
        if (res[0]) {
          this.SelectedFlights[0].DepartObject = res[0].DepartObject
          this.SelectedFlights[0].ArrivalObject = res[0].ArrivalObject
          this.mixinPlaneSetDate(res[0].DepartDate)
        }
        if (res[1]) {
          this.SelectedFlights[1].DepartObject = res[1].DepartObject
          this.SelectedFlights[1].ArrivalObject = res[1].ArrivalObject
          this.mixinPlaneSetDate(res[0].DepartDate, res[1].DepartDate)
        }
      }
      // 舱位等级 读取缓存移至获取舱等接口里
      let curSegMulPass = window.localStorage.HISTORY_QUERY_PLANE_MULTI_PASS
      if (window.localStorage.HISTORY_QUERY_PLANE_MULTI_PASS) {
        curSegMulPass = this.mixinPlaneGetFilterInterPlaneCityHistory(JSON.parse(window.localStorage.HISTORY_QUERY_PLANE_MULTI_PASS))
        let beOverdue = false
        if (curSegMulPass[0] && curSegMulPass[0].DepartDate < this.beTime(new Date())) {
          beOverdue = true
        }
        if (beOverdue) {
          curSegMulPass = curSegMulPass.map((d, i) => {
            let offsetD = 1
            let day = this.beTime(new Date())
            if (i !== 0) {
              offsetD = 3
              day = curSegMulPass[i - 1].DepartDate
            }
            d.DepartDate = this.getNewDate(day, 0, 0, offsetD)
            return d
          })
        }
        this.mulSelectedFlights = curSegMulPass
      }
    },

    /** 过滤国际机票城市当前历史缓存数据 */
    mixinPlaneGetFilterInterPlaneCityHistory(list) {
      let TravelType = Number(this.TravelType)
      let hasInterPlanePower = (TravelType === 0 && this.hasPower('因公:机票:国际机票查询')) || (TravelType === 1 && this.hasPower('因私:国际机票'))
      if (!hasInterPlanePower) {
        return list.map(v => {
          let DepartObject = v.DepartObject
          let ArrivalObject = v.ArrivalObject
          return {
            ...v,
            DepartObject: DepartObject && DepartObject.CountryType && DepartObject.CountryType !== '国际' ? DepartObject : {},
            ArrivalObject: ArrivalObject && ArrivalObject.CountryType && ArrivalObject.CountryType !== '国际' ? ArrivalObject : {}
          }
        })
      } else {
        return list
      }
    },

    /** 机票设置行程缓存 */
    mixinPlaneSetLocalStoryWithSegments() {
      if (this.isPlaneMultiPass) { // 机票多程
        window.localStorage.HISTORY_QUERY_PLANE_MULTI_PASS = JSON.stringify(this.mulSelectedFlights)
      } else {
        let currentSegments = this.SelectedFlights.slice(0, 2)
        window.localStorage.HISTORY_QUERY_PLANE = JSON.stringify(currentSegments)
      }
      window.localStorage.HISTORY_INTLFLIGHTCLASS = JSON.stringify(this.intlFlightClass)
      // 国内机票 先选人不展示舱位等级 顾不做缓存
      if (!this.isIntlPlane && !this.choosePassengerFirst4Plane) {
        window.localStorage.HISTORY_FLIGHTCLASS = JSON.stringify(this.flightClass)
      }
    },

    /** 机票设置行程缓存 */
    mixinPlaneSetHistoryTripStorage() {
      let SelectedFlights = JSON.parse(JSON.stringify(this.SelectedFlights))
      if (!this.isPlaneMultiPass) {
        this.$refs.RefsHistoryTrip && this.$refs.RefsHistoryTrip.setHistoryTripStorage(SelectedFlights[0])
      }
    },

    /** 历史记录点击选中回调 */
    mixinPlaneHistoryTripSelect(item) {
      this.SelectedFlights[0].DepartObject = item.DepartObject
      this.SelectedFlights[0].ArrivalObject = item.ArrivalObject
    },

    /** 校验是否是国际城市 */
    mixinPlaneCheckIsIntlCity(DepartObject, ArrivalObject) {
      return (DepartObject && DepartObject.CountryType === '国际') || (ArrivalObject && ArrivalObject.CountryType === '国际')
    },

    /** 获取城市名称 */
    mixinPlaneGetCityName(cityInfo) {
      if (cityInfo && cityInfo.CityCode) {
        return this.getAirPortName(cityInfo)
      }
      return ''
    }
  }
}
